export const host_51 = "https://activity.51job.com";
export const host_yjs = "https://activity.yingjiesheng.com";

// 各个对应的登录地址
export const loginUrl = {
  "51jobM": "https://login.51job.com/login.php?display=h5&lang=c&url=",
  "51jobPC": "https://login.51job.com/login.php?lang=c&url=",
  yjsM: "https://m.yingjiesheng.com/login?url=",
  yjsPC: "https://q.yingjiesheng.com/login?url=",
};

export const young_sign_key =
  "lhs3ayggr7fc00sjgskaupe6nrrlxod9tl1ct7hhdivvzdd2kj6hurj3fukhnt3r";
export const cupid_sign_key =
  "abfc8f9dcf8c3f3d8aa294ac5f2cf2cc7767e5592590f39c3f503271dd68562b";
